module.exports = __webpack_public_path__ + "static/media/spinner.b6efb238.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spinner.gif
// module id = 1199
// module chunks = 0